export interface CareAIChat {
  id: number;
  promptHistory: CareAIChatMessage[];
  lastChatTimestamp: string | null;
  preferences?: CareAIChatPreferences
}

export interface CareAIChatMessage {
  userPrompt: string;
  botResponse?: string;
}

export interface CareAIChatPreferences {
  sourceTypes: CareAIChatKnowledgeSource[],
  fromLastModified?: Date,
  includedTermsFilter: TermFilter
  excludedTermsFilter: TermFilter
  searchDepth?: SearchDepth,
}

export function createNewPreference(): CareAIChatPreferences {
  return {
    sourceTypes: [],
    fromLastModified: undefined,
    searchDepth: undefined,
    includedTermsFilter: {
      terms: [],
      targetFields: [],
      termRequirement: 0,
    },
    excludedTermsFilter: {
      terms: [],
      targetFields: [],
      termRequirement: 0,
    }
  };
}

export interface TermFilter {
  terms: string[];
  targetFields: number[];
  termRequirement: number;
}

export interface CareAIChatKnowledgeSource {
  name: string,
  enumId: number,
  superAdminRequired: boolean
}

export const allSources: CareAIChatKnowledgeSource[] = [
  {
    name: 'Dev wiki',
    enumId: 0,
    superAdminRequired: true
  },
  {
    name: 'Zendesk',
    enumId: 1,
    superAdminRequired: true
  },
  {
    name: 'Sharepoint',
    enumId: 2,
    superAdminRequired: false
  },
  {
    name: 'Dev Ops',
    enumId: 3,
    superAdminRequired: true
  },
  {
    name: 'Standard Operating Procedure (SOP)',
    enumId: 4,
    superAdminRequired: false
  },
  {
    name: 'Quality',
    enumId: 5,
    superAdminRequired: false
  },
];

export interface TermTarget {
  name: 'Title' | 'Content' | 'Tags';
  enumId: 0 | 1 | 2;
}

export const allTermTargets: TermTarget[] = [
  {
    name: 'Title',
    enumId: 0,
  },
  {
    name: 'Content',
    enumId: 1,
  },
  {
    name: 'Tags',
    enumId: 2,
  }
];

export interface TermRequirment {
  name: 'Any' | 'All';
  enumId: 0 | 1
}

export const allTermRequirements: TermRequirment[] = [
  {
    name: 'Any',
    enumId: 0,
  },
  {
    name: 'All',
    enumId: 1,
  }
];

export interface SearchDepth {
  name: 'Fast' | 'Balanced' | 'Deep';
  enumId: 0 | 1 | 2;
}

export const allSearchDepths: SearchDepth[] = [
  {
    name: 'Fast',
    enumId: 0,
  },
  {
    name: 'Balanced',
    enumId: 1,
  },
  {
    name: 'Deep',
    enumId: 2,
  }
];
